import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deleteWebhook } from '../../../../common/api/clients/webhooks.api';
import { queries } from '../../../../common/api/queryKeys/queries';

export const useWebhookDelete = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: deleteWebhook,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queries.webhooks.list._def });
        },
    });
};
